import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import {appRoutes} from './routerConfig';

import { AppComponent } from './app.component';
import {RouterModule} from "@angular/router";
import {HomeComponent} from "./page/home/home.component";
import {HttpClientModule} from "@angular/common/http";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TowerService} from "./api/service/tower.service";
import {LogsComponent} from "./page/logs/logs.component";
import {LogitemComponent} from "./page/logitem/logitem.component";
import {FormsModule} from "@angular/forms";
import {NavigationService} from "./shared/navigation.service";
import {EntryComponent} from "./page/entry/entry.component";
import {CallbackComponent} from "./page/callback/callback.component";
import {QueuesComponent} from "./page/queues/queues.component";

@NgModule({
  declarations: [
    AppComponent,
    EntryComponent,
    CallbackComponent,
    HomeComponent,
    LogsComponent,
    LogitemComponent,
    QueuesComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    NgbModule.forRoot(),
    FormsModule
  ],
  providers: [
    TowerService,
    NavigationService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts